import SolutionPageTemplate from "./SolutionPageTemplate";

const RelatoriosGestaoPrograma = () => (
  <SolutionPageTemplate
    title="Gestão do Programa"
    intro={[
      "Acompanhamos as ações realizadas por meio de relatórios e indicadores que auxiliam a empresa no monitoramento da participação e da evolução do programa de bem-estar.",
      "Essa gestão contribui para uma visão mais organizada das iniciativas implementadas e apoia a tomada de decisões relacionadas ao cuidado com os colaboradores.",
    ]}
    benefits={[
      "Acompanhamento das ações realizadas",
      "Relatórios de participação e adesão",
      "Identificação de oportunidades de melhoria",
      "Gestão organizada das iniciativas de bem-estar",
      "Apoio à tomada de decisão",
    ]}
    sectionId="relatorios-gestao-programa"
    modifier="solution-page--relatorios"
  />
);

export default RelatoriosGestaoPrograma;
